module.exports = __webpack_public_path__ + "static/img/gy.c908281a.svg";